import { Component, EventEmitter, Input, Output } from '@angular/core';
import { USER_TAG_META_MAP, USER_TAGS, UserTagViewModel } from '@interfaces';

@Component({
  selector: 'app-cr-user-tag-selector',
  templateUrl: './cr-user-tag-selector.component.html',
  styleUrls: ['./cr-user-tag-selector.component.scss'],
})
export class CrUserTagSelectorComponent {
  public userTags: UserTagViewModel[] = Object.values(USER_TAGS).map(tag => ({
    name: tag,
    icon: USER_TAG_META_MAP[tag].icon,
    color: USER_TAG_META_MAP[tag].color,
    label: `MANAGEMENT.TAG_MANAGER.TAG.${tag}`,
  }));

  @Input() selectedTag: USER_TAGS | null;
  @Output() selectedTagChanged = new EventEmitter<{ selectedTag: USER_TAGS }>();

  get selectedTagAsUserTag(): UserTagViewModel {
    return this.userTags.find(({ name }) => name === this.selectedTag);
  }
}
